export const PAGINATION_INDEXING = Object.freeze({
  FIRST_PAGE_NUMBER: 1,
  FIRST_PAGE_INDEX: 0,
  PAGE_INDEX_OFFSET: 1,
});

export const PAGINATION_PAGE_SIZES = Object.freeze({
  COMPACT: 5,
  DEFAULT: 10,
  LARGE: 20,
});

export const PAGINATION_DEFAULTS = Object.freeze({
  size: PAGINATION_PAGE_SIZES.DEFAULT,
  number: PAGINATION_INDEXING.FIRST_PAGE_INDEX,
  totalElements: 0,
});

// Keep unloaded pages and unknown totals distinct from empty results.
export const PAGINATION_SENTINELS = Object.freeze({
  UNLOADED_PAGE_INDEX: -1,
  UNKNOWN_TOTAL_ELEMENTS: -1,
});

export const PAGINATION_ITEM_TYPES = Object.freeze({
  PAGE: "page",
  NEXT: "next",
  LAST: "last",
  FIRST: "first",
  PREVIOUS: "previous",
});

export const PAGINATION_EVENTS = Object.freeze({
  DOCUMENT_CLICK: "click",
});

export const PAGINATION_DISPLAY = Object.freeze({
  CONTROL_SHAPE: "rounded",
  CONTROL_VARIANT: "outlined",
  EDGE_NEIGHBOR_OFFSET: 2,
});

export const PAGINATION_INPUT = Object.freeze({
  CONTROL_SIZE: "small",
  FIELD_TYPE: "number",
  DECIMAL_RADIX: 10,
  DIGITS_ONLY_PATTERN: /^\d*$/,
});

export const PAGINATION_MESSAGES = Object.freeze({
  TOTAL_ENTRIES_PREFIX: "out of",
  ENTRIES_LABEL: "entries",
  VISIBLE_RANGE_PREFIX: "Showing",
  SELECTED_ROWS_SUFFIX: " selected / ",
  MAXIMUM_PAGE_WARNING_PREFIX: "Maximum page number is",
  MINIMUM_PAGE_WARNING: `Page cannot be less than ${PAGINATION_INDEXING.FIRST_PAGE_NUMBER}`,
});

export const TABLE_COLUMN_DEFAULTS = Object.freeze({
  RESIZE_MODE: "onChange",
  WIDTHS: Object.freeze({
    minWidth: 50,
    width: 150,
    maxWidth: 400,
  }),
});
